import * as Dialog from "@radix-ui/react-dialog";
import * as React from "react";
import { ReactComponent as CloseIcon } from "assets/img/icons/header/close.svg";
import { Heading, Separator } from "components/elements";

type UploadModalProps = {
    button: React.ReactNode | null;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    title: React.ReactNode;
    children: React.ReactNode;
    blur?: boolean;
};

export const UploadModal = (props: UploadModalProps) => {
    const { button, children, isOpen, setIsOpen, title, blur } = props;

    return (
        <Dialog.Root open={isOpen} onOpenChange={(opened) => setIsOpen(opened)}>
            {button !== null && <Dialog.Trigger asChild>{button}</Dialog.Trigger>}
            <Dialog.Portal>
                <Dialog.Overlay
                    className={`fixed inset-0 z-50 bg-[#424242]/75 ${blur ? "backdrop-blur-sm" : ""} `}
                />

                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 flex max-h-[90vh] w-[90vw] max-w-[500px] -translate-x-1/2 -translate-y-1/2 flex-col rounded-2xl bg-white">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6">
                        <Dialog.Title asChild>
                            <div className="text-left align-middle font-sans text-[24px] font-bold leading-[100%] tracking-[0] text-[#424242]">
                                {title}
                            </div>
                        </Dialog.Title>
                        <Dialog.Close asChild>
                            <button aria-label="Close">
                                <CloseIcon className="-mt-2 h-[30px] w-[30px]" />
                            </button>
                        </Dialog.Close>
                    </div>

                    <Separator />

                    {/* Scrollable content */}
                    <div className="flex-1 overflow-y-auto p-6 pt-2">{children}</div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
